/**
 * UI Store
 * Global UI state management
 */

import { atomWithStorage } from 'jotai/utils';

/**
 * Developer mode.
 *
 * The SOP is the single source of truth: implementors author the SOP and see the
 * generated Workflow and Graph as READ-ONLY. Developer mode is the escape hatch —
 * when on, the workflow/graph editors and regeneration controls become available.
 *
 * Off by default and persisted per browser. The toggle itself lives in Settings and
 * is restricted to super admins, so an implementor cannot grant themselves edit.
 */
export const developerModeAtom = atomWithStorage<boolean>('kim-developer-mode', false);

// Pulse date range (serialized as ISO strings for localStorage)
export interface StoredDateRange {
	from: string | undefined;
	to: string | undefined;
}

export const PULSE_DATE_RANGE_KEY = 'pulse-date-range';

export const pulseDateRangeAtom = atomWithStorage<StoredDateRange | null>(PULSE_DATE_RANGE_KEY, null);

// Sub-protocol order in the protocol left panel, per protocol id — a browser-only view preference.
export const protocolSubOrderAtom = atomWithStorage<Record<string, string[]>>('protocol-sub-order', {}, undefined, {
	getOnInit: true
});
